import { gql } from 'apollo-angular'

import { SEO_META_FIELDS } from '../../fragments/seo.fragment'

export const GET_PAGE_BY_SLUG_QUERY = gql`
  query Pages($slug: String!, $locale: LocaleInputType) {
    Pages(where: { slug: { equals: $slug } }, locale: $locale, limit: 1) {
      docs {
        id
        slug
        title
        content
        updatedAt
        ${SEO_META_FIELDS}
      }
    }
  }
`
